var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.498 2.58014L20.6559 7.29008V16.71L12.498 21.4199L4.34015 16.71V7.29008L12.498 2.58014Z",
    fill: "#FF8736",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5009 3.92152L12.9255 1.85729L12.5082 1.61633L12.0908 1.85729L3.93297 6.56723L3.51562 6.80818V7.29009V16.71V17.1919L3.93297 17.4328L7.50832 19.4971L7.92566 18.7742L4.35031 16.71V7.29009L12.5082 2.58015L16.0835 4.64438L16.5009 3.92152ZM8.86147 19.3145L12.5082 21.4199L20.666 16.71V7.29009L17.0193 5.18467L17.4367 4.4618L21.0834 6.56723L21.5007 6.80818V7.29009V16.71V17.1919L21.0834 17.4328L12.9255 22.1428L12.5082 22.3837L12.0908 22.1428L8.44412 20.0373L8.86147 19.3145Z",
    fill: "#FF8736"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8051 8.36605L12.5119 4.73267L6.21875 8.36605V15.6328L12.5119 19.2662L18.8051 15.6328V8.36605ZM12.647 9.19763H11.9067L11.8233 10.5268L12.0325 13.665H12.647H13.2614L13.4706 10.5268L13.3872 9.19763H12.647ZM11.9487 14.5512L12.3486 14.1491L12.9156 14.1476L13.3177 14.5474L13.3193 15.1145L12.9194 15.5166L12.3524 15.5182L11.9503 15.1183L11.9487 14.5512Z",
    fill: "#FF8736"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.bbfbdf1a747295408253620ffb32e013.svg";
export { ForwardRef as ReactComponent };